import { render, staticRenderFns } from "./FormDocs.vue?vue&type=template&id=1b4449a1&lang=pug&"
import script from "./FormDocs.vue?vue&type=script&lang=js&"
export * from "./FormDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports